import React from "react"
import { Box, BoxProps } from "@chakra-ui/core"
import Stars from "../Stars"
import Heading from "../typography/Heading"
import lightFormat from "date-fns/lightFormat"
import Body from "../typography/Body"
import Paragraph from "../typography/Paragraph"

type ReviewProps = Omit<BoxProps, "title"> & {
  title: string
  body: string
  date: string
  rating: number
  reviewer: string
}

export default function Review({
  title,
  body,
  reviewer,
  date,
  rating,
  ...props
}: ReviewProps) {
  return (
    <Box {...props}>
      <Stars value={rating} justify="flex-start" mb="0.75rem" />
      <Heading as="h4" size="4" mb="0.5rem">
        {title}
      </Heading>
      <Body size="sm" mb="1rem" color="dusk">
        <Box as="span" fontWeight="500">
          {reviewer}
        </Box>{" "}
        on {lightFormat(new Date(date), "M/d/yyyy")}
      </Body>
      <Paragraph lineHeight="1.5rem">{body}</Paragraph>
    </Box>
  )
}
